type LoginBoxFormFieldErrorProps = Readonly<{
  children: string
}>

const LoginBoxFormFieldError = ({ children }: LoginBoxFormFieldErrorProps) => (
  <p className="text-primary-red mt-2 text-left text-sm">{children}</p>
)

export { LoginBoxFormFieldError, type LoginBoxFormFieldErrorProps }
